<template>
  <div>
    <pt-gene-lab-order ref="orderTable" :hideTitle="true" :billId="bill &&bill.id" :taskId="order.id" :isDialog="true" @selection-change="getSelectedOrder" @getOrderExportExcel="getOrderExportExcel" :canSelect="canSelect" :comePage="comePage" :hasDownload="hasDownload" @downloadExcel="downloadExcel">
      <div slot="otherBtn">
        <el-button type="primary" @click="handleRemove" :loading="removeLoading">移除</el-button>
        <el-button type="primary" :loading="addLoading" @click="handleAdd">新增</el-button>
        <!-- 委托单待回传之后才显示 -->
        <el-button type="primary" @click="handleDistribute" :loading="distributeLoading">分派任务</el-button>
      </div>

    </pt-gene-lab-order>

    <!-- 选择样品 -->
    <select-lab-order-dialog orderStatusEnum='ORDER_RECEIVED' :dialogVisible="showDialog" :billId="bill ? bill.id : ''" :onlyNoBill="!bill" @close="showDialog = false" @selectData="getSelectData" :selectedKeys="[]" :noExportOption="true"></select-lab-order-dialog>
  </div>
</template>

<script>
import ptGeneLabOrder from 'cps/lab-order/pt-gene-lab-order'
import selectLabOrderDialog from 'cps/common/select-lab-order-dialog.vue'
// 组件class前缀
const prefixCls = 'pt-production-task-detail'

export default {
  name: 'pt-production-task-detail',
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    bill: {
      type: Object,
      default: () => {}
    },
    canSelect: Boolean,
		comePage: String,
		hasDownload:Boolean//是否可下载（委托单详情的样本列表有下载操作）
  },
  computed: {
  },
  components: {
    ptGeneLabOrder,
    selectLabOrderDialog
  },
  data () {
    return {
      selectOrder: [],
      removeLoading: false,
      distributeLoading: false,
      showDialog: false,
      addLoading: false
    }
  },
  methods: {
		downloadExcel(params){
      let data={
        ...params
      }
      this.downloadLoading=true
      this.$store.dispatch('getProductionTaskDownloadExcel',data).then(res => {
        this.$message.success('生产任务下载成功')
        this.downloadLoading=false
      }).catch(err => {
        this.$message.error(err||'生产任务下载失败')
        this.downloadLoading=false
      })
		},
    getOrderExportExcel (params) {
      let data = {
        ...params
      }
      this.exportLoading = true
      this.$store.dispatch('getOrderExportExcel', data).then(res => {
        this.$message.success('样本导出成功')
        this.exportLoading = false
      }).catch(err => {
        this.$message.success(err || '样本导出失败')
        this.exportLoading = false
      })
    },
    reload () {
      this.$refs.orderTable.reload()
      this.$emit('on-reload')
    },
    getSelectData (val) {
      console.log('===val', val)
      this.showDialog = false

      this.addLoading = true
      let data = {
        billId: this.bill.id,
        taskId: this.order.id,
        orderIds: val.map(e => e.id)
      }
      this.$store.dispatch('addOrdersToTask', data).then(res => {
        this.$message.success('操作成功')
        this.reload()
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.addLoading = false
      })
    },
    getSelectedOrder (data) {
      this.selectOrder = data
    },
    handleRemove () {
      if (!this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      this.$confirm(`您勾选了${this.selectOrder.length}条样品信息，是否确认从该任务单中移除?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.removeLoading = true
        let data = {
          billId: this.bill.id,
          taskId: this.order.id,
          orderIds: this.selectOrder.map(e => e.id)
        }
        this.$store.dispatch('removeOrdersFromTask', data).then(res => {
          this.$message.success('操作成功')
          this.reload()
        }).catch(err => {
          this.$message.warning(err || '操作失败')
        }).finally(() => {
          this.removeLoading = false
        })
      })
    },
    handleAdd () {
      this.showDialog = true
    },
    handleDistribute () {
      if (!this.selectOrder.length) {
        this.$message.warning('请先勾选样品')
        return
      }
      this.distributeLoading = true
      let data = {
        taskId: this.order.id,
        orderIds: this.selectOrder.map(e => e.id)
      }

      this.$store.dispatch('assginPre', data).then(data => {
        this.$router.push(`/distribute-task/${data.taskId}?isTask=true`)
      }).catch(err => {
        this.$message.warning(err || '操作失败')
      }).finally(() => {
        this.distributeLoading = false
      })
    }
  }

}
</script>

<style module lang="less">

</style>
